import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const AppleIcon = ({ color = 'white' }: { color?: string }) => {
	return (
		<Icon
			width="auto"
			height="12px"
			viewBox="0 0 11 13"
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.84975 11.904C8.20604 12.5352 7.49583 12.4368 6.81887 12.1392C6.09915 11.8356 5.4412 11.8164 4.6811 12.1392C3.73455 12.552 3.23217 12.432 2.6621 11.904C-0.556427 8.55599 -0.081368 3.45599 3.57659 3.26399C4.46376 3.31199 5.0849 3.75959 5.60747 3.79679C6.38419 3.63719 7.12766 3.17999 7.95901 3.23999C8.95782 3.32159 9.70485 3.71999 10.2037 4.43639C8.14903 5.68439 8.63597 8.42039 10.5231 9.18839C10.1455 10.1904 9.66091 11.1804 8.84856 11.9124L8.84975 11.904ZM5.53621 3.22799C5.44001 1.74 6.6336 0.515996 8.00652 0.395996C8.19535 2.112 6.46257 3.39599 5.53621 3.22799Z"
				fill={color}
			/>
		</Icon>
	);
};
